export default __webpack_public_path__ + "static/media/ticktick.ce5004d8.mp3";